import React from 'react';
import styled from 'styled-components';

import ThemeColors from "../../config/themeColors";
import { TableType } from '../../Types';

interface Props {
    scroll?: boolean;
    dashboard?: boolean;
    filterheader?: boolean;
    stickymodal?: boolean;
    tableType: TableType;
    children: React.ReactNode;
    style?: React.CSSProperties;
}

const DefaultTable = styled.table<Props>`
    margin-bottom: 1rem;
    border: ${props => props.scroll ? null : '1px solid ' + ThemeColors.tableBorder};
    background: ${ThemeColors.white};
    width: 100%;
    max-width: 100%;
    border-collapse: collapse;
    td, th {
        padding: .75rem;
    }
    td {
        border-top: 1px solid ${ThemeColors.tableBorder};
        ${props => props.filterheader ? 'border-bottom: 1px solid #dee2e6;' : null}; 
    }
    thead td {
        border-top: 0;
    }
    tr.TotalRow {
        background: #dee2e6;
    }
    thead th, th {
        vertical-align: middle;
        border-bottom: 0;
    }    
    td a {
        color: ${ThemeColors.text};
        text-decoration: none;
    }
    tbody tr:nth-of-type(odd) {
        background-color: rgba(0,0,0,.03);
    }
    tbody tr:hover {
        background-color: rgba(0, 0, 0, 0.07);
    }
    tbody tr.badForecast, tbody tr.badForecast:nth-of-type(odd), tbody tr.badForecast:hover {
        background-color: #f7adad;
    }
    tbody tr.noForecast, tbody tr.noForecast:nth-of-type(odd), tbody tr.noForecast:hover {
        background-color: #ffd6ab;
    }
    tbody tr.gereed, tbody tr.gereed:nth-of-type(odd), tbody tr.gereed:hover {
        background-color: ${ThemeColors.ftgGreenLight};
    }
    th {
        position: sticky;        
        top: ${props => props.stickymodal ? '-1px' : '69px'};
        background-color: ${ThemeColors.white}; 
        z-index: 1;
    }
    th:after {
        content: "";
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        height: 1px;
        border-bottom: 1px solid #dee2e6;
    }
    tbody tr:first-child td {
        border-top: 0;
    }
    @media (max-width: 480px) {
        font-size: ${props => props.dashboard ? '70%' : '86%'};
        th, td {
            padding: 0.4rem;
        }
        td svg {font-size: 120%;}
    }
`;

const TvLayout = styled(DefaultTable)`
    background: #373737;
    margin-bottom: 0;
    border: 0;
    color: ${ThemeColors.white};
    * {
        font-size: 107%;
    }
    thead {
        background: transparent;
    }
    th {
        background-color: #404040; 
    }
    th:after {
        content: "";
        position: absolute;
        bottom: 0px;
        width: 100%;
        left: 0;
        height: 1px;
        border-bottom: 0;
    }
    th, td {
        border-color: #404040;
    }
    tbody tr:nth-of-type(odd) {
        background-color: rgba(255,255,255,.05);
    }
    tbody tr.badForecast, tbody tr.badForecast:nth-of-type(odd), tbody tr.badForecast:hover {
        background-color: #ce4040;
    }
    tbody tr.noForecast, tbody tr.noForecast:nth-of-type(odd), tbody tr.noForecast:hover {
        background-color: #ce8f40;
    }
    tbody tr.gereed, tbody tr.gereed:nth-of-type(odd), tbody tr.gereed:hover {
        background-color: #a8ca92;
    }
    td a {
        color: #fff;
    }
    svg {
        font-size: 20px !important;
        cursor: pointer;
    }
    @media (max-width: 480px) {
        font-size: 100%;
    }
`;

const FixedHeight = styled(DefaultTable)`
    margin-bottom: 0;
    tbody {
        min-height: 80px;
        max-height: 300px;
        overflow-y: auto;
        width: 100%;
    }
    thead tr {
        background: #f1f1f1;
        overflow: hidden;
    }
    thead tr th {
        border: 0;
        background: #f1f1f1;
        padding: 0.75rem 1.2rem;
        position: static;
    }
    thead tr th:after {
        display: none;
    }
    tbody tr {
        border-bottom: 1px solid #f1f1f1;
        overflow: hidden;
    }
    tbody tr:last-child {
        border: 0;
    }
    tbody td {
        border: 0;
        padding: 0.75rem 1.2rem;
    }
    @media (max-width: 480px) {
        tbody {
            max-height: 150px;
        }    
    }

`;

const DoubleSticky = styled(DefaultTable)`
    thead th {
        background-color: ${ThemeColors.white}; 
        z-index: 1;
        position: sticky;   
    }
    thead tr:nth-child(1) th {
        top: 69px;
    }
    thead tr:nth-child(2) th {
        top: 115px;
    }
`

const Table = (props: Props) => {

    let Table = <DefaultTable {...props}>{props.children}</DefaultTable>;

    switch (props.tableType) {
        case TableType.TvLayout:
            Table = <TvLayout {...props}>{props.children}</TvLayout>;
            break;
        case TableType.FixedHeight:
            Table = <FixedHeight {...props}>{props.children}</FixedHeight>;
            break;
        case TableType.DoubleSticky:
            Table = <DoubleSticky {...props}>{props.children}</DoubleSticky>;
            break;
    }

    return Table;
    
};

export default Table;